import { Button } from "@src/appV2/redesign/components/Button";
import { ShiftBottomSheetArrivalTimeDescription } from "@src/appV2/redesign/Shift/BottomSheet/ArrivalTime/Description";
import { ShiftBottomSheetBookabilityCriteriaCard } from "@src/appV2/redesign/Shift/BottomSheet/BookabilityCriteriaCard";

import { WorkerShiftDetailsArrivalTimeTitle } from "./Title";

interface WorkerShiftDetailsArrivalTimeCardProps {
  startDatetime: Date;
  targetArrivalTime: Date;
  workplaceTimezone: string;
  onGetDirections: () => void;
}

export function WorkerShiftDetailsArrivalTimeCard(props: WorkerShiftDetailsArrivalTimeCardProps) {
  const { startDatetime, targetArrivalTime, workplaceTimezone, onGetDirections } = props;

  return (
    // TODO: this should be renamed to something decoupled from shift bottom sheet
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="neutral"
      title={
        <WorkerShiftDetailsArrivalTimeTitle
          targetArrivalTime={targetArrivalTime}
          workplaceTimezone={workplaceTimezone}
        />
      }
      description={
        <ShiftBottomSheetArrivalTimeDescription
          startDatetime={startDatetime}
          workplaceTimezone={workplaceTimezone}
        />
      }
      illustrationType="clock-error"
      footer={
        <Button fullWidth variant="outlined" size="medium" onClick={onGetDirections}>
          Get directions
        </Button>
      }
    />
  );
}
